import { SET_UNREAD_MESSAGES } from "../types";

export const setUnreadMessages = (payload: any) => ({
  type: SET_UNREAD_MESSAGES,
  payload
});
